import { useContext, useCallback } from 'react';
import toastContext from './toastContext';
import { Toast, ToastTypes } from './toastType';

const useToastState = (): ToastTypes => {
    const context = useContext(toastContext);

    if (!Object.keys(context).length) {
        throw new Error('ToastContext must be used within its provider');
    }

    const { dispatch } = context;

    const setToast = useCallback(
        (
            toast: Omit<Toast, 'id' | 'toastDuration' | 'removeToast'>,
            id: string,
            toastDuration: number = 3000
        ) => {
            dispatch({
                type: 'SET_TOAST',
                payload: {
                    ...toast,
                    id,
                    toastDuration,
                    removeToast: () => dispatch({ type: 'REMOVE_TOAST', payload: id }),
                },
            });
        },
        [dispatch]
    );

    return {
        ...context,
        setToast,
    };
};

export default useToastState;
